import * as React from 'react';

import { CombinedProductionViewProps } from '../../components/list/production';
import ListPerformances from '../../components/list/performances';
import moment from 'moment'; 

const ListMonthsView: React.StatelessComponent<CombinedProductionViewProps> = props => {

    const pdpHeader = (
        <>
            <h3 id={`Prod-Group-${props.production.productionTitle}`} data-demo-label="Production Title">
                {props.production.productionTitle}
            </h3>
            {<p>{props.production.productionSynopsis}</p>}
        </>
    );
    let firstDate = moment(props.production.performances[0].date);
    let lastDate = moment(props.production.performances[props.production.performances.length - 1].date);
    let hideDateRange = firstDate.isSame(lastDate,'date');

    return ( 
        <li className="ace-subs-item">
            <article className="ace-subs-package">
                <div className="ace-layout ace-layout-2-eq ace-layout-borderless-mobile">
                    <div>
                        <div className="ace-subs-package-img">
                            <img src={props.production.pdpImageSrc ?? props.production.pdpImageSrc} alt="" />
                        </div>
                    </div>
                    <div>
                        <div className="ace-subs-package-details stack-sm">
                            <div>

                                <p className="tag">
                                    {
                                        hideDateRange
                                            ? moment(props.production.performances?.[0]?.date).format('MMM D')
                                            : (moment(props.production.performances?.[0]?.date).format('MMM D') +"-"+
                                                moment(props.production.performances?.[props.production.performances.length - 1]?.date).format('MMM D'))

                                    }
                                </p>
                                {pdpHeader}
                            </div>
                            <div>
                                <button className="btn btn-wide"
                                    aria-expanded="false" aria-controls={`Panel_package_${props.production.productionSeasonId}`}>
                                    <span data-panel-open-text>Show&nbsp;</span>
                                    <span data-panel-close-text>Hide&nbsp;</span>
                                    <span>Performances</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item space-top-lg">
                    <div className="reveal-panel" data-subs-panel aria-hidden="true" id={`Panel_package_${props.production.productionSeasonId}`}>
                        <div className="ace-subs-package-perfs">
                            <ListPerformances filteredPerformances={props.filteredPerformances} />
                        </div>
                    </div>
                </div>
            </article>
        </li>
    );
}

export default ListMonthsView;